export const JSON_BEAUTIFY_SPACES = 4;

/**
 * A JSON file's content as the app caches it: always minified, so equal content compares equal,
 * with a flag for whether the file itself is formatted differently (e.g. beautified).
 */
export interface JsonFileContent {
    text: string;
    beautified: boolean;
}

/** The text written for a JSON file. */
export function stringifyJson(content: unknown, beautify = false): string {
    return beautify ? JSON.stringify(content, null, JSON_BEAUTIFY_SPACES) : JSON.stringify(content);
}

/** The cached form of a downloaded file's text. Text that isn't JSON is kept as is, for the parser to reject. */
export function readJsonContent(raw: string): JsonFileContent {
    try {
        const text = JSON.stringify(JSON.parse(raw));
        return {text, beautified: text !== raw};
    } catch {
        return {text: raw, beautified: false};
    }
}

/** The cached form of content we write with `stringifyJson(content, beautify)`. */
export function writtenJsonContent(content: unknown, beautify = false): JsonFileContent {
    return {text: stringifyJson(content), beautified: beautify};
}
